import React, { useEffect, useRef, useState } from 'react';
import Button from './Button';
import ReactToPrint from 'react-to-print';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IDateRange, TStateOfScriptInjection } from 'redux/app/vessel/inspector/types';
import Modal from 'components/app/_common/Modal';
import { inspectorActions, inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';

type TMarpolPrintIconProps = {
    dateRange: IDateRange;
    isDataLoading: boolean;
    printIframe: (id: string) => Promise<boolean>;
    isDisabled: boolean;
    printRef: React.MutableRefObject<HTMLDivElement>;
} & PropsFromRedux;

const MarpolPrintIcon = (props: TMarpolPrintIconProps) => {
    const {
        printIframe,
        isDisabled,
        printRef,
        setStateOfScriptInjection,
        stateOfScriptInjection,
    } = props;

    const reactToPrintRef = useRef<any>();
    const [
        isShowPrintCoverPagesDialogVisible,
        setIsShowPrintCoverPagesDialogVisible,
    ] = useState<boolean>(false);

    const onToggleShowPrintCoverPagesDialogVisible = () => {
        setIsShowPrintCoverPagesDialogVisible((val) => !val);
    };

    // useEffect(() => {
    //     if (dateRange.startDate && dateRange.endDate) {
    //         const diff = moment().diff(dateRange.startDate, 'M');
    //         const isPrintDisabled = diff > 3;
    //         setIsPrintDisabled(isPrintDisabled);
    //     }
    // }, [dateRange]);

    useEffect(() => {
        if (stateOfScriptInjection === 'ACTIVE') {
            setTimeout(() => {
                setStateOfScriptInjection('ENDED');
            }, 5000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateOfScriptInjection]);

    useEffect(() => {
        if (stateOfScriptInjection === 'ENDED') {
            setIsShowPrintCoverPagesDialogVisible(false);
            printIframe('printIframe');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateOfScriptInjection]);

    useEffect(() => {
        return () => {
            setStateOfScriptInjection('IDLE');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Button
                disabled={isDisabled}
                iconName="print"
                onClick={() => {
                    // INFO: open the modal. Printing with cover pages is opt-in feature
                    // Primary is No. On click of no, no cover pages to be shown.
                    setIsShowPrintCoverPagesDialogVisible(true);
                }}
            />
            {
                <div
                    style={{
                        display: 'none',
                    }}
                >
                    <ReactToPrint
                        trigger={() => (
                            <Button disabled={isDisabled} iconName="print" />
                        )}
                        content={() => printRef.current}
                        ref={reactToPrintRef}
                    />
                </div>
            }
            {isShowPrintCoverPagesDialogVisible && (
                <Modal
                    isActive={isShowPrintCoverPagesDialogVisible}
                    onClose={onToggleShowPrintCoverPagesDialogVisible}
                    className="items-start"
                >
                    <div className="flex justify-center my-12 font-redhat-text ">
                        <div
                            className=" h-auto p-6 my-1 bg-white text-gray-800 rounded-lg relative"
                            style={{ width: '50%' }}
                        >
                            <div className="text-base">
                                Do you want to print the selected log without
                                the cover pages?
                            </div>
                            {stateOfScriptInjection === 'ACTIVE' ? (
                                <div className="mt-2 ">
                                    <p className="animate-pulse text-center">
                                        Generating coverpages, please wait ...
                                    </p>
                                    <div className="flex justify-center my-2">
                                        <svg
                                            className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            ) : null}
                            <div className="flex justify-end mt-2 2xl:mt-6">
                                <button
                                    className="ws-button py-1.5 rounded-md h-9 min-w-20"
                                    disabled={
                                        stateOfScriptInjection === 'ACTIVE'
                                    }
                                    onClick={() => {
                                        setIsShowPrintCoverPagesDialogVisible(
                                            false
                                        );
                                        reactToPrintRef.current?.handlePrint();
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    disabled={
                                        stateOfScriptInjection === 'ACTIVE'
                                    }
                                    onClick={() => {
                                        props.setShowCoverPages(true);
                                        setStateOfScriptInjection('ACTIVE');
                                    }}
                                    className="py-1.5 h-9 mx-1 ml-2 font-medium text-gray-800 bg-gray-300 shadow-sm outline-none rounded-md min-w-20 focus:outline-none focus:ring disabled:text-gray-500 disabled:bg-gray-400"
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

function mapStateToProps(store: IStore) {
    const inspectorStore = inspectorSelectors._getStore(store);

    const showCoverPages = inspectorSelectors.getShowCoverPages(inspectorStore);
    const stateOfScriptInjection =
        inspectorSelectors.getStateOfScriptInjection(inspectorStore);
    return {
        showCoverPages,
        stateOfScriptInjection,
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        setStateOfScriptInjection(
            stateOfScriptInjection: TStateOfScriptInjection
        ) {
            return dispatch(
                inspectorActions.document.setStateOfScriptInjection(
                    stateOfScriptInjection
                )
            );
        },
        setShowCoverPages(show: boolean) {
            return dispatch(inspectorActions.document.setShowCoverPages(show));
        },
    };
}

const reduxContainer = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxContainer>;
export default reduxContainer(MarpolPrintIcon);